import { QuestionCircleFilled } from "@ant-design/icons";
import { Popover } from "antd";
import { useDispatch } from "react-redux";
import SKRActions from "../../../pages/S2R/redux/actions";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

import "./question-mark.scss";
import paymentsService from "../../services/payments-service";

const text = <span>Help and Support</span>;

const QuestionMark = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.profile.user);

  const content = (
    <div className="help-support-menu">
      <p>Help center (coming soon) </p>
      <a target="_blank" href="https://discord.gg/AQFexVmq">
        <p>Join our Discord </p>
      </a>
      <p
        onClick={() => {
          dispatch(SKRActions.contactOpen(true));
        }}
      >
        Contact support
      </p>
      {user?.membership === "free" && (
        <p
          onClick={() => {
            paymentsService
              .createSession({
                priceId: "price_1KQjcODD6XrDuzW97XZ2tsoC",
                user: user,
                successUrl: "https://mobile-vizcom.web.app/s2r",
                cancelUrl: "https://mobile-vizcom.web.app/s2r",
              })
              .then((session) => {
                // reroute to checkout
                window.location.href = session.data.url;
              })
              .catch((error) => {
                console.log(error);
              });
          }}
        >
          Upgrade to Pro
        </p>
      )}
    </div>
  );
  return (
    <div className="question-mark">
      <Popover
        placement="leftBottom"
        title={text}
        content={content}
        trigger="click"
      >
        <QuestionCircleFilled
          className="question-mark-svg"
          twoToneColor="#fff"
        />
      </Popover>
    </div>
  );
};

export default QuestionMark;
